import clsx from 'clsx'
import React, {useEffect, useRef, useState} from 'react'
import {KTSVG} from '../../components'

type Props = {
  title?: string
  loading?: any
  className?: string
  icon?: any
  list: any
  menuLeftOrRight?: 'start | end'
  value?: any
  // menu dropdown width = trigger width
  fitContent?: boolean
}

const DropdownButton: React.FC<Props> = ({
  title,
  className = '',
  menuLeftOrRight = 'end',
  icon,
  list,
  loading,
  value,
  fitContent = false,
}) => {
  const [show, setShow] = useState(false)
  const rootRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (rootRef.current && !rootRef.current.contains(event.target as Node)) {
        setShow(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const handleItemClick = (action?: any) => {
    action?.()
    setShow(false)
  }

  const renderIcon = () => {
    if (loading) {
      return <div className='ms-2 spinner-border spinner-border-sm' role='status' />
    } else if (icon) {
      return icon
    } else {
      return (
        <KTSVG
          path='/media/gori/common/threeDots.svg'
          small={false}
          className='rounded-circle bg-hover-light p-1'
        />
      )
    }
  }

  const handleList = list.filter((data) => {
    return !data.hidden
  })

  return (
    <div
      className={clsx('position-relative', fitContent ? 'd-inline-block' : 'd-block')}
      ref={rootRef}
    >
      <div
        className={clsx(
          'align-items-center',
          fitContent ? 'd-inline-flex' : 'd-flex justify-content-end',
          className,
          {'pe-none': handleList.length === 0}
        )}
        aria-expanded={show}
        onClick={() => setShow((prev) => !prev)}
      >
        {title}
        {renderIcon()}
      </div>
      <div
        data-bs-popper='static'
        style={fitContent ? {minWidth: 0} : undefined}
        className={clsx('dropdown-menu fw-bold fs-7 py-2', {
          [`dropdown-menu-lg-${menuLeftOrRight}`]: menuLeftOrRight,
          'w-100': fitContent,
          show,
        })}
      >
        {handleList.length > 0 &&
          handleList.map((child: any, index: number) => {
            return (
              <div
                className={clsx(
                  `dropdown-item py-3 cursor-pointer text-gray-900 fw-bold`,
                  child?.className,
                  {
                    'bg-primary text-white': child.value && value === child.value,
                    'text-hover-primary bg-hover-primary-light': !(
                      child.value && value === child.value
                    ),
                  }
                )}
                key={index}
                onClick={() => handleItemClick(child?.action)}
              >
                <span className='menu-link'>{child.label}</span>
              </div>
            )
          })}
      </div>
    </div>
  )
}

export {DropdownButton}
